import { QueryClient, QueryKey } from "@tanstack/react-query";

export type InvalidationKey = string | QueryKey;

export const invalidateQueryKeys = (
    queryClient: QueryClient,
    queryKeys: InvalidationKey[],
) => {
    queryKeys.forEach((queryKey) => {
        void queryClient.invalidateQueries({
            queryKey: typeof queryKey === "string" ? [queryKey] : queryKey,
        });
    });
};
